export const toPersianNumbers = (number) => {
  if (number === null || number === undefined) return "";
  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  return number.toString().replace(/\d/g, (x) => persianDigits[x]);
};